import type {
  Customer,
  CreateCustomerRequest,
  UpdateCustomerRequest,
} from "../../types";
import type { EndpointBuilder } from "@reduxjs/toolkit/query/react";

/**
 * Customer Mutation Endpoints
 * Handles write operations for customer management
 */
export const customerMutations = (
  builder: EndpointBuilder<any, string, string>,
) => ({
  /** Create a new customer */
  createCustomer: builder.mutation<Customer, CreateCustomerRequest>({
    query: (customer) => ({
      url: "admin/customers",
      method: "POST",
      body: customer,
    }),
    invalidatesTags: [{ type: "Customers", id: "LIST" }],
  }),

  /** Update existing customer */
  updateCustomer: builder.mutation<
    Customer,
    { id: string; data: UpdateCustomerRequest }
  >({
    query: ({ id, data }) => ({
      url: `admin/customers/${id}`,
      method: "PATCH",
      body: data,
    }),
    invalidatesTags: (_result, _error, { id }) => [
      { type: "Customers", id },
      { type: "Customers", id: "LIST" },
    ],
  }),

  /** Activate customer */
  activateCustomer: builder.mutation<Customer, string>({
    query: (id) => ({
      url: `admin/customers/${id}/activate`,
      method: "POST",
    }),
    invalidatesTags: (_result, _error, id) => [
      { type: "Customers", id },
      { type: "Customers", id: "LIST" },
    ],
  }),

  /** Suspend customer */
  suspendCustomer: builder.mutation<Customer, string>({
    query: (id) => ({
      url: `admin/customers/${id}/suspend`,
      method: "POST",
    }),
    invalidatesTags: (_result, _error, id) => [
      { type: "Customers", id },
      { type: "Customers", id: "LIST" },
    ],
  }),
});
